import store from "@frameworks/web/redux/store";
import { ADD_DASHBOARD_HOLDING_SUMMARY, DASHBOARD_HOLDING_START_LOADER, DASHBOARD_HOLDING_STOP_LOADER, DASHBOARD_HOLDING_ERROR, DASHBOARD_HOLDING_HIDE_ERROR, } from "@frameworks/web/redux/interfaces/Reports/iDashboardHoldingSummary";
class DashboardHoldingSummary {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getDashboardHoldingSummary(dashboardData, reducerName) {
        this.dispatch({
            type: ADD_DASHBOARD_HOLDING_SUMMARY,
            payload: dashboardData,
            reducerName,
        });
    }
    loader(type) {
        this.dispatch({
            type: DASHBOARD_HOLDING_START_LOADER,
            reducerName: type,
        });
    }
    stopLoader(type) {
        this.dispatch({
            type: DASHBOARD_HOLDING_STOP_LOADER,
            reducerName: type,
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: DASHBOARD_HOLDING_ERROR,
            payload: {
                errorData: payload,
            },
            reducerName: errorType,
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: DASHBOARD_HOLDING_HIDE_ERROR,
            reducerName: errorType,
        });
    }
}
export default DashboardHoldingSummary;
